export { default as CustomWidthSideBySide } from './CustomWidthSideBySide';
